import { message } from "antd";

const antdAsyncMessageLoading = ({
  text = "In progress...",
  key = "default",
}) =>
  message.loading({
    content: text,
    key,
    duration: 0,
  });

const antdAsyncMessageSuccess = ({
  text = "Successfully completed",
  key = "default",
}) =>
  message.success({
    content: text,
    key,
    duration: 2,
  });

const antdAsyncMessageError = ({ text = "Error occurred", key = "default" }) =>
  message.error({
    content: text,
    key,
    duration: 2,
  });

export {
  antdAsyncMessageError,
  antdAsyncMessageSuccess,
  antdAsyncMessageLoading,
};
